<div class="rangebox" *ngIf="uniqueAccommodationCodes.length > 1">
    <button data-target="#collapseaccommodation" data-toggle="collapse" class="collapsebtn" type="button">Accommodation Type</button>
    
    <div id="collapseaccommodation" class="collapse show">
      <div class="boxins">
        <ul class="accommodationul">
          <li *ngFor="let code of uniqueAccommodationCodes">
            <div class="squaredThree">
              <input
                type="checkbox"
                name="check"
                class="farecheckbox"
                [id]="'squaredThree' + code"
                (change)="onAccommodationChange(code, $event.target.checked)">
              <label [for]="'squaredThree' + code"></label>
            </div>
            <label class="llbl" [for]="'squaredThree' + code">{{ code }}</label>
          </li>
        </ul>
      </div>
    </div>
  </div>
  